import React from 'react';
import { BookOpen, CalendarCheck, CheckCircle2, Sparkles, Lock, Zap, ShieldCheck } from 'lucide-react';
import { useInView } from '../hooks/useInView';
const basePlanFeatures = ['Pack completo de 6 Tomos en PDF', 'El Sistema de Presupuesto Inverso', 'Plan para eliminar deudas', 'Guía para tu fondo de emergencia', 'Primeros pasos para invertir', 'Mentalidad Caudal', 'Acceso inmediato por email'];
const upsellFeatures = ['Todo lo del Pack de 6 Tomos', 'Plan de implementación guiado de 30 días', 'Paso a paso calmo y simple para aplicar el método', 'Dejá de llegar raspando a fin de mes', 'Cerrá el mes con margen real', 'Acompañamiento estructurado día por día'];
export function PricingSection() {
  const {
    ref: headerRef,
    isVisible: headerVis
  } = useInView();
  const {
    ref: cardsRef,
    isVisible: cardsVis
  } = useInView();
  return <section className="py-24 px-4 bg-[#0F0F0F]" data-id="element-189">
      <div className="max-w-5xl mx-auto" data-id="element-190">
        <div ref={headerRef} className={`text-center mb-16 ${headerVis ? 'anim-fade-up' : 'anim-hidden'}`} data-id="element-191">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-192">
            Elegí tu camino
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-193">
            Podés empezar con el método por tu cuenta, o sumar el plan guiado de
            30 días para implementarlo sin dudas.
          </p>
        </div>

        <div ref={cardsRef} className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-stretch" data-id="element-194">
          {/* Upsell Plan */}
          <div className={`relative bg-[#141414] border-2 border-gold-500/50 rounded-2xl p-8 flex flex-col shadow-[0_0_40px_rgba(212,168,83,0.1)] ${cardsVis ? 'anim-fade-up' : 'anim-hidden'}`} data-id="element-195">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-500 text-background text-xs font-bold px-4 py-1.5 rounded-full flex items-center gap-1.5 uppercase tracking-wider" data-id="element-196">
              <Sparkles className="w-3.5 h-3.5" data-id="element-197" />
              Recomendado
            </div>
            <div className="flex items-center gap-3 mb-6" data-id="element-198">
              <div className="w-12 h-12 bg-gold-500/10 rounded-xl flex items-center justify-center" data-id="element-199">
                <CalendarCheck className="w-6 h-6 text-gold-500" data-id="element-200" />
              </div>
              <div data-id="element-201">
                <h3 className="text-xl font-bold text-white" data-id="element-202">
                  Pack + Implementación 30 Días
                </h3>
                <p className="text-sm text-gold-400" data-id="element-203">
                  El método + acompañamiento guiado
                </p>
              </div>
            </div>
            <div className="mb-8" data-id="element-204">
              <span className="text-4xl font-bold text-gold-400" data-id="element-205">$29.990</span>
              <span className="text-sm text-gray-400 ml-2 line-through" data-id="element-206">
                $49.980
              </span>
            </div>
            <ul className="space-y-3 mb-10 flex-grow" data-id="element-207">
              {upsellFeatures.map((feature, index) => <li key={index} className="flex items-start gap-3" data-id="element-208">
                  <CheckCircle2 className="w-5 h-5 text-gold-500 shrink-0 mt-0.5" data-id="element-209" />
                  <span className="text-gray-200 text-sm" data-id="element-210">{feature}</span>
                </li>)}
            </ul>
            <a href="https://checkout.librofy.store/checkouts/cn/hWNASJdISiP0Me8jH4lqfy1y/es-ar?_r=AQABcPwJwttUIMWLoin5ubVoyPsYXDSrVAmVoDS7Y0RHwQk&cart_link_id=llCctF35&preview_theme_id=160306823389" className="w-full block text-center bg-gradient-to-b from-gold-400 to-gold-600 text-background font-bold text-lg py-4 px-6 rounded-xl shadow-[0_0_30px_rgba(212,168,83,0.3)] hover:shadow-[0_0_40px_rgba(212,168,83,0.5)] hover:scale-[1.02] active:scale-[0.98] transition-all duration-300" target="_blank" rel="noopener noreferrer" data-id="element-211">
              Quiero el Pack + Implementación
            </a>
          </div>

          {/* Base Plan */}
          <div className={`bg-[#141414] border border-gray-800 rounded-2xl p-8 flex flex-col ${cardsVis ? 'anim-fade-up anim-delay-2' : 'anim-hidden'}`} data-id="element-212">
            <div className="flex items-center gap-3 mb-6" data-id="element-213">
              <div className="w-12 h-12 bg-gray-800 rounded-xl flex items-center justify-center" data-id="element-214">
                <BookOpen className="w-6 h-6 text-gray-300" data-id="element-215" />
              </div>
              <div data-id="element-216">
                <h3 className="text-xl font-bold text-white" data-id="element-217">
                  Pack de 6 Tomos
                </h3>
                <p className="text-sm text-gray-400" data-id="element-218">El método completo</p>
              </div>
            </div>
            <div className="mb-8" data-id="element-219">
              <span className="text-4xl font-bold text-white" data-id="element-220">$19.990</span>
            </div>
            <ul className="space-y-3 mb-10 flex-grow" data-id="element-221">
              {basePlanFeatures.map((feature, index) => <li key={index} className="flex items-start gap-3" data-id="element-222">
                  <CheckCircle2 className="w-5 h-5 text-gray-500 shrink-0 mt-0.5" data-id="element-223" />
                  <span className="text-gray-300 text-sm" data-id="element-224">{feature}</span>
                </li>)}
            </ul>
            <a href="https://checkout.librofy.store/checkouts/cn/hWNASLMFcoZLI7CuL7ZBbarq/es-ar?_r=AQABIpbZY25iZdIr--IJ59tvhh0FWdD8Tl99Y7M_xLV34A0&cart_link_id=2ubHl0TS&preview_theme_id=160306823389" className="w-full block text-center bg-gray-800 hover:bg-gray-700 text-white font-bold text-lg py-4 px-6 rounded-xl hover:scale-[1.02] active:scale-[0.98] transition-all duration-300" target="_blank" rel="noopener noreferrer" data-id="element-225">
              Quiero el Pack de 6 Tomos
            </a>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 mt-8 text-xs md:text-sm text-gray-300 font-medium" data-id="element-226">
          <div className="flex items-center gap-1.5" data-id="element-227">
            <Lock className="w-4 h-4 text-gold-500" data-id="element-228" />
            <span data-id="element-229">Compra 100% segura</span>
          </div>
          <span className="hidden md:inline text-gray-500" data-id="element-230">•</span>
          <div className="flex items-center gap-1.5" data-id="element-231">
            <Zap className="w-4 h-4 text-gold-500" data-id="element-232" />
            <span data-id="element-233">Acceso inmediato</span>
          </div>
          <span className="hidden md:inline text-gray-500" data-id="element-234">•</span>
          <div className="flex items-center gap-1.5" data-id="element-235">
            <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-236" />
            <span data-id="element-237">Garantía de 30 días</span>
          </div>
        </div>
      </div>
    </section>;
}